<div class="container-fluid" *transloco="let t; read:'userBar'">
	<div class="row justify-content-center">
		<img class="profile-picture-big" src="assets/icons/icon-72x72.png" alt="profile picture">
	</div>
	<div class="row justify-content-center">
		<h2>{{currentUser?.name}}</h2>
	</div>
	<div class="row justify-content-center">
	</div>
	<div class="row justify-content-center align-items-center clinic-wrapper">
		<div class="col">
		</div>
		<div class="col">
		</div>
	</div>
	<div class="row bottom-icons">
		<button class="icon-col btn" [routerLink]="[EMPTY_PATH, SETTINGS_PATH]">
			<shared-icon-sprite svgId="general-gear" width="45" height="45"></shared-icon-sprite>
			<span>{{t('settings')}}</span>
		</button>
		<button class="icon-col btn"  [routerLink]="[EMPTY_PATH, SETTINGS_PATH, USER_PROFILE_PATH]">
			<shared-icon-sprite svgId="general-businessman-04" width="45" height="45"></shared-icon-sprite>
			<span>{{t('userProfile')}}</span>
		</button>
	</div>
</div>
